<template lang="pug">
.product-list.container.mx-auto
    .spacer
    .main-area(v-if="areas.main && areas.main.length")
        .menu
            .shop-menu-current-level(v-if="visibleCurrentLevelMenu")
                nav(ref="nav")
                    tree-menu(
                        :items="currentLevelItems",
                        :allowMultipleActiveItems="true"
                        :active-ids="activeMenuItemIDs",
                        :max-depth="3",
                        :delay="400",
                        :show="true",
                        :showChildren="true"
                    )
        .products
            section(
                v-for="(section, index) in areas.main",
                :key="section.id",
                :class="section.key",
                v-if="isAllowed(section.key, 'main')"
            )
                ProductList(
                    v-if="section.key === 'categoryproducts'",
                    :section="section",
                    :key="section.id",
                    default-orientation="horizontal"
                )
</template>

<script>
import Page from '@/views/Page';
import { get, cloneDeep } from '@/helpers';

import ProductList from '@/extensions/shop/components/ProductList';
import NestedSet from '@/nested-set-lib';
import { mapGetters } from 'vuex';

export default {
    name: 'Products',
    extends: Page,
    components: {
        ProductList
    },
    computed: {
        currentLevelItems() {
            let tree;
            if (this.activeMenuItemIDs && this.activeMenuItemIDs.length) {
                let items = [];
                const menu = this.menus.find(menu => menu.key === 'product-menu');
                items = get(menu, 'menuItems') || [];
                items = cloneDeep(items);

                if (this.activeMenuItemIDs.length >= 2) {
                    const parentID = this.activeMenuItemIDs[this.activeMenuItemIDs.length - 2];
                    if (items.length) {
                        const target = items.find(el => el.id === parentID);
                        if (target) {
                            tree = NestedSet.createTree(items, target._lft, target._rgt);
                        }
                    }
                } else {
                    const rootID = this.activeMenuItemIDs[0];
                    if (items.length) {
                        const full = NestedSet.createTree(items);
                        if (full && full.length) {
                            const item = full.find(el => el.id === rootID);
                            if (item && item.children && item.children.length) tree = item.children;
                        }
                    }
                }
            }

            return tree;
        },
        visibleCurrentLevelMenu() {
            const items = this.currentLevelItems || [];
            return items.filter(item => !item.disabled && !item.hidden).length > 0;
        },
        activeMenuItemIDs() {
            let IDs = [];

            const menus = this.menus || [];
            const menu = menus.find(menu => menu.key === 'product-menu');
            const items = get(menu, 'menuItems') || [];

            const path = this.$route.path;
            const item = items.find(el => el.path === path);

            if (item) {
                const ancestors = NestedSet.getAncestors(cloneDeep(items), item);
                IDs = [...ancestors, item].map(el => el.id);
            }

            return IDs;
        },
        ...mapGetters({
            menus: 'menus',
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            defaultTax: 'shop/defaultTax'
        })
    },
    methods: {
        isAllowed(key, area = 'main') {
            switch (area) {
                // case 'header':
                //   return ['banner', 'slider'].includes(key);

                case 'main':
                default:
                    return ['categoryproducts'].includes(key);
            }
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"


button.active
    @apply border-gray-500 bg-gray-500
section.slider,
section.banners
    padding: 0
section.heading
    padding-bottom: 0
.product-list
    display: flex
    flex-direction: column
    margin-top: 20px
    @screen lg
        margin-top: 3rem
.main-area
    @apply max-w-full mx-auto
    flex-direction: column
    .products
        @apply w-full
.main-area, section
    display: flex
    flex-grow: 1
    margin-bottom: 30px
.menu
    @apply ml-0 pr-8 mb-8 hidden
    @screen lg
        @apply block

    .tree-menu
        ::v-deep li
            width: 100%
            .tree-item > a
                @apply block border-b border-solid px-2 py-2 transition duration-200 ease-in-out
                border-color: $color-primary
                width: 200px
                .sub-right
                    @apply hidden
                &:hover
                    @apply text-white
                    background-color: $color-primary
            &:first-child > .tree-item> a
                @apply border-t border-solid
                border-color: $color-primary
            > ul.tree-menu
                @apply hidden
            &.active > ul.tree-menu
                @apply block
                .tree-item > a
                    @apply pl-2 border-0
                    padding-top: 5px
                    padding-bottom: 5px
                    &:before
                        content:'-'
                        margin-right: 5px

            &.active.is-child-lvl-1 > div.tree-item > a
                @apply text-white font-semibold
                background-color: $color-primary

@screen lg
    .main-area
        flex-direction: row
        margin: 0
    .menu
        @apply mx-0
</style>
